module.exports = __webpack_public_path__ + "img/uk.97d42b22.svg";